import { Component, ComponentRef, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { AutoreplaceService } from 'src/app/services/autoreplace/autoreplace.service';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Autoreplace } from 'src/app/utils/interfaces/new/autoreplace.interface';
import { Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { Courrier } from 'src/app/utils/interfaces/new/Courrier';
import { CreateCourrier } from 'src/app/utils/interfaces/new/create-courrier.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { VisualisationConsultation } from 'src/app/utils/interfaces/new/visualisation-consultation.interface';
import { DisplayDocumentComponent } from '../../display-document/display-document.component';
import { SearchInputFragment } from '../../search-input/search-input.fragment';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';
import { OrdonnancesService } from 'src/app/services/consultation/ordonnances/ordonnances.service';
import { Ordonnance } from 'src/app/utils/interfaces/new/ordonnance';
import { environment } from 'src/environments/environment';
import { CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { LoadingModalFragment } from '../loading/loading-modal.fragment';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { choisirEntete, RessourceService } from 'src/app/services/ressource/ressource.service';
import { FroalaEditorDirective } from 'angular-froala-wysiwyg';
import "froala-editor/js/plugins/table.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/print.min.js';
import 'froala-editor/js/plugins/help.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/languages/fr.js';
import { OrdonnanceLibre } from 'src/app/utils/interfaces/new/ordonnance-libre';

@Component({
  selector: 'app-edit-ordonnance',
  templateUrl: './edit-ordonnance.fragment.html',
  styleUrls: [
    './edit-ordonnance.fragment.scss',
    '../modal.fragment.scss'
  ],
  /**
   * Ce fragment est appelé dans une modal et ne récupère pas les modules
   * On les ajoute donc ici pour y avoir accès
   */
  providers: [
    DirectivesModule
  ]
})
export class EditOrdonnanceFragment implements OnInit {

  editorContent: string = '';
  editorOptions: Object = {
    pluginsEnabled: [
      'table', 'fontSize', 'fontFamily',
      'emoticons',
      'specialCharacters', 'embedly',
      'fullscreen','selectAll','help',
      'paragraphFormat', 'paragraphStyle', 'align', 'lists', 'colors', 'lineHeight', 'quote'
    ],
    fontSize: ['6','8','10', '12', '14', '16', '18', '24', '36'],
    language: 'fr',
    toolbarButtons: [
      [ 'insertTable','embedly', 'emoticons', 'specialCharacters', ],
      [ 'bold', 'italic', 'underline', 'strikeThrough','textColor', 'backgroundColor','clearFormatting'],
      ['fontFamily', 'fontSize', 'quote', 'paragraphFormat', 'paragraphStyle'],
      ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'lineHeight', 'outdent', 'indent'],
      ['undo', 'redo', 'fullscreen', 'selectAll', 'help']
    ],
    tabSpaces: 8,
    key: environment.froalaKey,
    attribution: false,
    width: '100%'
    };

  TEXT_ALD_ENCART = "<p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions relatives au traitement de l'affection de longue durée reconnue</p><p style=\"text-align:center\">(liste ou hors liste)&nbsp;(AFFECTION EXONERANTE)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions SANS RAPPORT avec l'affection de longue durée</p><p style=\"text-align:center\">(MALADIES INTERCURRENTES)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p><br></p>"

  @ViewChild('froalaDrop') public froalaEditorDirective!:FroalaEditorDirective;
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;
  @ViewChild('searchInput') public searchInput: SearchInputFragment;

  editorInstance: any = null;
  initControls: any = null;

  errorMessage: string;
  isFullscreen = false;

  patientId: string;
  consultationId: string;
  ordonnanceId: string;
  isMedical: boolean;
  isOrdoLibre: boolean;

  ordonnanceForm: FormGroup;
  consultation: Consultation;
  patient: InfosPatient;
  textToPrint: any;

  private _originalTitle: string;

  tableName: string = "tag";

  isTag = true;
  isGlossaire = false;
  isPenseBete = false;
  isMaquette = false;
  isCriteres = false;
  isDossierPatient = false;
  isCourrierPerso = false;
  isMedicamentPerso = false;
  choisirEnteteParam: boolean = false;
  profil: Profil;
  printDirectly: boolean;




  private _initialAutoReplaceArray: Array<Autoreplace> = [];
  autoReplaceBodyTable: Paginated<Autoreplace> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0
  }

  autoReplaceColumnTable = [
    { title: this.tableName, data: 'quickKey' }
  ];

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeEditOrdonnanceModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _consult: ConsultationService,
    private _replace: AutoreplaceService,
    private _view: ViewContainerRef,
    private _displayDocumentSrv: DisplayDocumentService,
    private _modal: ModalService,
    private _login: LoginService,
    private _strUtilsSrv: StringUtilsService,
    private _ordonnance: OrdonnancesService,
    private _courrierSrv: CourriersService,
    public modalSrv: ModalService,
    public viewContainerRef: ViewContainerRef,
    private _snakeBarSrv: SnackbarService,
    private _cabinet : CabinetService,
    private _resourceSrv: RessourceService


  ) { }


 /**
   * Initialisation de l'éditeur pour accéder aux méthodes de froala pour cibler l'éditeur, pour le drag and drop
   * @param initControls
   */
 initialize(initControls: any) {
  this.initControls = initControls;

  this.initControls.initialize();

  setTimeout(() => {
    this.editorInstance = this.initControls.getEditor();
  });
}


  async ngOnInit(): Promise<void> {
    this.consultation = await this._consult.findOne(this.consultationId);
    this.ordonnanceForm = this._formBuilder.group({
      titre: [this.consultation.titre, Validators.required],
      isEnteteVide: [''],
      isPiedVide: [''],
      retenueEnvoiDmp: [true],
    });

    const currentProfilStr = localStorage.getItem('currentProfil');
        if (currentProfilStr && currentProfilStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          this.profil = currentProfil as Profil;
          //on récupère les préférences de l'utilisateur
          const params = await this._resourceSrv.getResourceSettings(this.profil.id, 'profil');

          if (params) {
            const activerChoisirEntete = params.find(setting => setting.settingKey === choisirEntete) ;
              if (activerChoisirEntete){
                this.choisirEnteteParam= JSON.parse(activerChoisirEntete.settingValue);
              }else{
                this.choisirEnteteParam = false;
              }
              
              const retenueEnvoiDmpSetting = params.find(setting => setting.settingKey === 'retenueEnvoiDmp');
              if (retenueEnvoiDmpSetting) {
                this.ordonnanceForm.patchValue({ retenueEnvoiDmp: JSON.parse(retenueEnvoiDmpSetting.settingValue) });
              }
        }
      }

    this.autoReplaceBodyTable.objects = await this.getListByName(this.tableName);
    this._initialAutoReplaceArray = this.autoReplaceBodyTable.objects;

    if (this.textToPrint) {
      this.editorContent = this.textToPrint;
    }
  }

  public closeEditOrdonnanceModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public async displayDoctorsNamesModale(cabinetDoctors: Destinataire[]): Promise<string | null> {
    try {
      const doctorsColumnTable = [
        { title: 'Choisir un médecin :', data: 'name', label: 'Nom du Médecin' }
      ];

      const doctorsData = cabinetDoctors.map(doctor => ({
        name: `${doctor.nom} ${doctor.prenom}`,
        id: doctor.id
      }));

      const modale = this._modal.openModalSelectList(
        this._view,
        'Sélection d\'une en-tête médecin',
        doctorsColumnTable,
        doctorsData,
        'Choisir un médecin :'
      );
      modale.instance.validButtonLabel = 'Sélectionner';

      return new Promise<string | null>((resolve, reject) => {
        const sub = modale.instance.closeEmitter.subscribe(async (res) => {
          let load: ComponentRef<LoadingModalFragment> | undefined;
          try {
            if (res) {
              load = this._modal.openLoading(this._view);
              resolve(res.id);
            } else {
              resolve(null);
            }
          } catch (error) {
            console.error("Erreur lors du traitement :", error);
            reject(error);
          } finally {
            modale.destroy();
            sub.unsubscribe();
            if (load) {
              load.destroy();
            }
          }
        });
      });
    } catch (error) {
      console.error("Erreur lors de la récupération des headers :", error);
      return null;
    }

  }

  async previewImpression() {
    let ordonnance:Ordonnance;
    let ordonnanceLibre: OrdonnanceLibre;
    if (this.isMedical) {
      // Récupération des informations de l'ordonnance
      ordonnance = await this._ordonnance.findOneOrdonnanceMedicamenteuse(this.ordonnanceId);
    }else if (this.isOrdoLibre) {
      // Récupération des informations de l'ordonnance libre
      ordonnanceLibre = await this._ordonnance.findOneOrdonnanceLibre(this.ordonnanceId);
    }

    let courrierText = this.editorContent;

    // TODO Eprescription ; Enchainer
    if (courrierText && courrierText !== '') {
      const currentUser = this._login.getCurrentUser();
      const currentProfil = this._login.getCurrentProfil();
      const printOrdo: Courrier = {
        id: this.consultationId,
        titre: this.ordonnanceForm.controls['titre'].value,
        courrierText: courrierText,
        isApercuImpression: false,
        isDuplicata: false,
        isImpressionPatient: false,
        isSelectCorrespondant: false,
        isVilleDate: false,
        isNomPatient: false,
        isEnteteVide: this.ordonnanceForm.controls['isEnteteVide'].value,
        isPiedVide: this.ordonnanceForm.controls['isPiedVide'].value,
        retenueEnvoiDmp: this.ordonnanceForm.controls['retenueEnvoiDmp'].value,
        isOrdo: true,
        creationDate: moment().toDate(),
        auteur: {
          id: currentProfil.id,
          nom: currentUser.nom,
          prenom: this._strUtilsSrv.uppercaseFirstCharString(currentUser.prenom),
          qualite: currentProfil.qualite
        },
        consultation: {
          id: this.consultationId
        },
        ordonnance: this.isMedical ? ordonnance : ordonnanceLibre
      }
      let displayDocumentInstance;

      if (this.choisirEnteteParam === true) {

        const cabinetProfessionnals: Destinataire[] = await this._cabinet.findCurrentCabinetProfils();
        const cabinetDoctors: Destinataire[] = cabinetProfessionnals.filter(pro => pro.qualite !== "Secrétariat médical");

        if (cabinetDoctors.length > 1) {
          // Afficher la modale pour sélectionner un médecin
          const idDoctor: string = await this.displayDoctorsNamesModale(cabinetDoctors);
          if (!idDoctor) {
            // Si aucun médecin n'a été sélectionné, ne pas continuer
            this._snakeBarSrv.openSnackBar("Veuillez sélectionner un médecin pour continuer.");
            return;
          }

          // Si un médecin a été sélectionné, continuer avec l'affichage du document
          displayDocumentInstance = await this._displayDocumentSrv.displayDocument(
            this._view,
            await this._displayDocumentSrv.courrierToDisplayContentData(
              printOrdo,
              this.patientId,
              null,
              null,
              idDoctor
            ),
            this.printDirectly
          ) as ComponentRef<DisplayDocumentComponent>;

        } else if (cabinetDoctors.length === 1) {
          displayDocumentInstance = await this._displayDocumentSrv.displayDocument(
            this._view,
            await this._displayDocumentSrv.courrierToDisplayContentData(
              printOrdo,
              this.patientId,
              null,
              null,
              cabinetDoctors[0].id
            ),
            this.printDirectly
          ) as ComponentRef<DisplayDocumentComponent>;
        }

      } else {
        displayDocumentInstance = await this._displayDocumentSrv.displayDocument(
          this._view,
          await this._displayDocumentSrv.courrierToDisplayContentData(printOrdo, this.patientId),
          this.printDirectly
        ) as ComponentRef<DisplayDocumentComponent>;
      }

      // Ici on change le titre de la page pour mieux maitriser le nommage du fichier lors de l'enregistrement
      const titleElem = document.head?.getElementsByTagName('title')?.[0];
      if (titleElem && this.consultation && this.patient) {
        this._originalTitle = titleElem.text;
        // <date de l’acte><libellé type document><prénom><numéro de dossier>.pdf (le champ <numéro de dossier> est optionnel)
        titleElem.text = `${moment(this.consultation.date).format('DD-MM-YYYY')}_ordonnance_${this.patient.nom}_${this.patient.prenom}`;
      }

      displayDocumentInstance.onDestroy(() => {
        if (titleElem) {
          titleElem.text = this._originalTitle;
          this._originalTitle = undefined;
        }
        this.closeEditOrdonnanceModal();
      });
    } else {
      this._modal.openAlert(this._view, "Ordonnance non remplie", "Vous devez remplir l'ordonnance pour pouvoir avoir un aperçu.");
    }
  }

  async dropped(event: any) {
    const autoRep = this.autoReplaceBodyTable.objects[event.previousIndex];
    if (autoRep.isFunction) {
      if (this.tableName === "dossierPatient" && autoRep.quickKey === "ConsultationsPatient") {

        const ar = await this._replace.findOnePatientByNameAndKey(this.tableName, autoRep.quickKey, this.patientId);
        if (ar?.note) {
          autoRep.note = ar.note;
        } else {
          autoRep.note = `${autoRep.quickKey}`;
        }

        const modalSelect = this._modal.openModalSelectConsultation(this._view, JSON.parse(autoRep.note) as Consultation[]);
        const subService = this._modal.closeEmitter.subscribe(async response => {
          if (response.object && (response.object as VisualisationConsultation[]).length > 0) {
            if (response?.object) {
              response.object.cartouchePatientVisible = true;
            }
            autoRep.note = await this._consult.visualisation(response.object);
            this.matchesAndTexte(autoRep);
            this._modal.close(modalSelect);
            subService.unsubscribe();
          } else {
            this._modal.close(response.fragment);
            subService.unsubscribe();
          }
        })
      } else {
        let newStr = `${autoRep.quickKey}`;

        let ar: Autoreplace;
        switch (newStr) {
          case "DateConsultation":
            ar = await this._replace.findOnePatientByNameAndKey(this.tableName, autoRep.quickKey, this.consultationId);
            break;
          default: {
            ar = await this._replace.findOnePatientByNameAndKey(this.tableName, autoRep.quickKey, this.patientId);
            break;
          }
        }
        if (ar?.note) {
          newStr = ar.note;
        }
        autoRep.note = newStr;
        this.matchesAndTexte(autoRep);
      }
    } else {
      this.matchesAndTexte(autoRep);
    }
  }

  async matchesAndTexte(autoRep: Autoreplace) {
    let texte = autoRep.note;

    //replace variables
    if (this.tableName === "glossaire" || this.tableName === "penseBete" || this.tableName === "courrierPerso") {
      let regex = /\@.*?\@/gim;

      let matches = texte.match(regex);
      if (!matches) {
        matches = [texte];
      }

      let matchesWord: string[] = [];
      for (let word of matches) {
        const wordWoutAt = word.includes('@') ? word.split('@')[1] : word;
        const nameKey = wordWoutAt.split('.');

        let newStr = `${autoRep.quickKey} `;
       //récupère tous les éléments de la catégorie "this.tableName" car on ne peut pas utiliser findOnePatientByNameAndKey avec ces catégories
       const ar = await this._replace.findPatientListByName(this.tableName, this.patientId);

       for(let a of ar){ //On recherche en bdd l'élément qui contient le texte qu'on utilise et on le push dans matchesWord
         if(a.note===matches[0]){
           newStr = a.note;
         }
        }

        matchesWord.push(newStr);
      }
      let i = 0;
      texte = texte.replace(regex, val => {
        const result = matchesWord[i];
        i++;
        return result;
      });
    }

    this.editorInstance.html.insert(texte);
  }

  addAld() {
    const editor = this.editorInstance;
    if (!editor) return;
    const before = "<p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions relatives au traitement de l'affection de longue durée reconnue</p><p style=\"text-align:center\">(liste ou hors liste)&nbsp;(AFFECTION EXONERANTE)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br>"
    const after = "<p><br></p><p style=\"text-align:center\">________________________________________________________________________________</p><p style=\"text-align:center\"><br></p><p style=\"text-align:center\">Prescriptions SANS RAPPORT avec l'affection de longue durée</p><p style=\"text-align:center\">(MALADIES INTERCURRENTES)</p><p style=\"text-align:center\">________________________________________________________________________________</p><p><br></p>"
    let selHtml = '';

    if (editor.selection.isCollapsed()){ // on a pas de selection
      // HTML exact de la sélection (avec mise en forme)
      selHtml = '<p><br></p>';
      // Remplace la sélection par le nouveau contenu
      editor.html.insert(`${before}${selHtml}${after}`);
      return;
    } else { // on a une selection
      // HTML exact de la sélection (avec mise en forme)
      selHtml = editor.html.getSelected() || '';
      // Remplace la sélection par le nouveau contenu
      editor.html.insert(`${before}${selHtml}${after}`);
    }
    // editor.html.insert(this.TEXT_ALD_ENCART);
  }


  async getListByName(name: string): Promise<Autoreplace[]> {
    return await this._replace.findByName(name);
  }

  async changeTable(tableInfo: string) {

    const tableTitles = {
        tag: 'tag',
        glossaire: 'Glossaire',
        penseBete: 'Pense-bêtes',
        maquette: 'Maquettes',
        critere: 'Critères',
        dossierPatient: 'Dossier patient',
        courrierPerso: 'Courriers personnalisés',
        medicamentPerso:'Médicaments saisie libre'
    };

    if (!tableTitles[tableInfo]) {
        console.error('Le nom de la colonne n\'existe pas.');
        return;
    }

    this.searchInput.searchInput = '';

    this.tableName = tableInfo;

    this.autoReplaceColumnTable[0].title = tableTitles[tableInfo];
    this.autoReplaceBodyTable.objects = await this.getListByName(tableInfo);
    this.toggleTab(tableInfo);


    this._initialAutoReplaceArray = this.autoReplaceBodyTable.objects;
}

//Si du texte est saisi par l'utilisateur on modifie le contenu du courrier enrgistré, et non pas de l'ordonnance.
//Cela permet de commenter une ordonnance et de l'enregistrer en tant que courrier.
  public createCourrier() {
    const loader = this.modalSrv.openLoading(this.viewContainerRef);
    try {
      let courrier: CreateCourrier = {
        idConsultation: this.consultationId,
        titre: "Ordonnance : " + this.ordonnanceForm?.controls?.['titre']?.value,
        courrierText: this.editorContent,
        versionCourrier: 1
      }
      this._courrierSrv.create(courrier, this.consultationId)

      loader.destroy();
      this.modalSrv.close(loader);
      this._snakeBarSrv.openSnackBar('L\'ordonnance a bien été enregistrée dans les courriers');

    } catch (e) {
      console.error(e);
      loader.destroy();
      this.modalSrv.close(loader);
    }

  }

public toggleTab(tabName: string) {
  switch (tabName) {
    case 'tag':
      {
        this.isTag = true;
        this.isGlossaire = false;
        this.isPenseBete = false;
        this.isMaquette = false;
        this.isCriteres = false;
        this.isDossierPatient = false;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = false;

       break;
      }
    case 'glossaire':
      {
        this.isTag = false;
        this.isGlossaire = true;
        this.isPenseBete = false;
        this.isMaquette = false;
        this.isCriteres = false;
        this.isDossierPatient = false;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = false;

        break;
      }
    case 'penseBete':
      {
        this.isTag = false;
        this.isGlossaire = false;
        this.isPenseBete = true;
        this.isMaquette = false;
        this.isCriteres = false;
        this.isDossierPatient = false;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = false;

        break;
      }
    case 'maquette':
      {
        this.isTag = false;
        this.isGlossaire = false;
        this.isPenseBete = false;
        this.isMaquette = true;
        this.isCriteres = false;
        this.isDossierPatient = false;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = false;
        break;
      }
    case 'critere':
      {
        this.isTag = false;
        this.isGlossaire = false;
        this.isPenseBete = false;
        this.isMaquette = false;
        this.isCriteres = true;
        this.isDossierPatient = false;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = false;
        break;
      }
    case 'dossierPatient':
      {
        this.isTag = false;
        this.isGlossaire = false;
        this.isPenseBete = false;
        this.isMaquette = false;
        this.isCriteres = false;
        this.isDossierPatient = true;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = false;

       break;
      }
    case 'courrierPerso':
      {
        this.isTag = false;
        this.isGlossaire = false;
        this.isPenseBete = false;
        this.isMaquette = false;
        this.isCriteres = false;
        this.isDossierPatient = false;
        this.isCourrierPerso = true;
        this.isMedicamentPerso = false;

        break;
      }
    case 'medicamentPerso':
      {
        this.isTag = false;
        this.isGlossaire = false;
        this.isPenseBete = false;
        this.isMaquette = false;
        this.isCriteres = false;
        this.isDossierPatient = false;
        this.isCourrierPerso = false;
        this.isMedicamentPerso = true;
        break;
      }

    default: {
      this.isTag = false;
      this.isGlossaire = false;
      this.isPenseBete = false;
      this.isMaquette = false;
      this.isCriteres = false;
      this.isDossierPatient = false;
      this.isCourrierPerso = false;
      this.isMedicamentPerso = false;
     break;
    }
  }}

  public filterAutoreplaceList(needle: string): void {
    const _normalizeStr = (str: string): string => {
      return this._strUtilsSrv.removeAccents(str).toLowerCase();
    };

    if (needle && needle !== '') {
      this.autoReplaceBodyTable.objects = this._initialAutoReplaceArray.filter(a => _normalizeStr(a.quickKey).includes(_normalizeStr(needle)));
    } else {
      this.autoReplaceBodyTable.objects = this._initialAutoReplaceArray;
    }
  }
}
